import React from 'react';
import SignupPage from '../../features/signup/SignupPage';
export default function Signup() {
  return <SignupPage />;
}
